// extracted by mini-css-extract-plugin
module.exports =  {"alert":"aM4_fs7LvF4XV6YnQ4dT","wrapper":"D2Zp8YA5ddJOgdXj82JA"};